/**
 * Creates a local flat-earth projection centered on (centerLat, centerLng).
 * Converts WGS84 degrees to local meters (X = east, Z = south).
 * 1 unit = 1 meter, approximately valid within a few km of the center.
 */

const EARTH_RADIUS = 6_371_000; // meters
const DEG2RAD = Math.PI / 180;

export function createProjection(centerLat, centerLng) {
  const cosLat  = Math.cos(centerLat * DEG2RAD);
  const latScale = EARTH_RADIUS * DEG2RAD;        // meters per degree latitude
  const lngScale = EARTH_RADIUS * cosLat * DEG2RAD; // meters per degree longitude

  return {
    centerLat,
    centerLng,

    /**
     * Project geographic coordinates to local XZ.
     * X = east (positive = right in Three.js default view)
     * Z = south (positive = forward in Three.js default view)
     */
    project(lat, lon) {
      return {
        x:  (lon - centerLng) * lngScale,
        z: -(lat - centerLat) * latScale,
      };
    },

    /** Inverse projection (for debugging / minimap). */
    unproject(x, z) {
      return {
        lat: centerLat + (-z / latScale),
        lon: centerLng + ( x / lngScale),
      };
    },
  };
}
